module.exports = __webpack_public_path__ + "img/people-frame.e085a747.webp";